// @ts-nocheck
import { Estimation } from '../types/estimation';
import { ICard } from './kanbanBoard/models/BoardModel';
import { IEstimatable } from '../models/IEstimatable';
import { useEffect, useState } from 'react';

const Estimations: React.FC<{ cards: ICard<IEstimatable>[]; projectReleaseId: number | null }> = ({
  cards,
  projectReleaseId,
}) => {
  const [estimation, setEstimation] = useState<Estimation>({
    estimateTime: 0,
    spentTime: 0,
    remainingTime: 0,
  });

  const calculateReleaseEstimation = () => {
    const isReleaseDefined = !!projectReleaseId;

    const TaskKeys = {
      SpentInRelease: 'taskSpentTimeInRelease',
      EstimateInRelease: 'taskEstimateTimeInRelease',
      Spent: 'taskSpentTime',
      Estimate: 'taskEstimateTime',
    } as const;

    type TaskKeyType = (typeof TaskKeys)[keyof typeof TaskKeys];
    // Helper to safely access the property
    function getTaskValue(content: IEstimatable | undefined, key: TaskKeyType): number {
      if (content && key in content) {
        // TypeScript: content[key] is possibly any, so cast to number or fallback to 0
        const value = content[key as keyof IEstimatable];
        return typeof value === 'number' ? value : 0;
      }
      return 0;
    }

    const spentKey = isReleaseDefined ? TaskKeys.SpentInRelease : TaskKeys.Spent;
    const estimateKey = isReleaseDefined ? TaskKeys.EstimateInRelease : TaskKeys.Estimate;

    const { spentTime, estimateTime } = cards.reduce(
      (total, card) => ({
        spentTime: total.spentTime + getTaskValue(card?.content, spentKey),
        estimateTime: total.estimateTime + getTaskValue(card?.content, estimateKey),
      }),
      { spentTime: 0, estimateTime: 0 }
    );

    return {
      spentTime,
      estimateTime: estimateTime === 0 ? null : estimateTime,
      remainingTime: estimateTime - spentTime,
    } as Estimation;
  };

  useEffect(() => {
    if (cards?.length) {
      const est = calculateReleaseEstimation();
      setEstimation(est);
    } else {
      setEstimation({
        estimateTime: 0,
        spentTime: 0,
        remainingTime: 0,
      });
    }
  }, [cards]);

  return (
    <>
      <div className="d-flex flex-row kanban-card__text kanban-release__text">
        <div>
          <span className="d-inline-block" data-toggle="tooltip" title={'Estimate'}>
            <div className="kanban-card__estimate estimate">
              {estimation.estimateTime?.toFixed(2) ?? '0.00'}
            </div>
          </span>
        </div>
        <div>
          <span className="d-inline-block" data-toggle="tooltip" title={'Spent'}>
            <div className="kanban-card__estimate spent">
              {estimation.spentTime?.toFixed(2) ?? '0.00'}
            </div>
          </span>
        </div>
        <div>
          <span className="d-inline-block" data-toggle="tooltip" title={'Remaining'}>
            <div
              className={`kanban-card__estimate ${
                estimation.estimateTime - estimation.spentTime >= 0 ? 'remaining' : 'debt'
              }`}
            >
              {Math.abs(estimation.remainingTime ?? 0).toFixed(2)}
            </div>
          </span>
        </div>
      </div>
    </>
  );
};

export default Estimations;
